<template>
  <b-taginput
    :data="filteredCountries"
    :placeholder="$t('compSuperadminSettingsAllowedCountries.label')"
    :allow-new="false"
    v-model="buffer"
    :open-on-focus="true"
    ref="allowedCountryInput"
    @input="$emit('input', buffer)"
    :create-tag="(tagToAdd) => createTag(tagToAdd)"
    rounded
    icon="caret-right"
    @typing="getFilteredCountries"
    autocomplete
  >
    <template slot-scope="props">
      <flag :iso="props.option.countryCode" /> &nbsp;
      {{ props.option.countryName }} ({{ props.option.countryCode }})
    </template>
    <template #selected="props">
      <b-tag
        v-for="(tag, index) in props.tags"
        :key="index"
        rounded
        :tabstop="false"
        ellipsis
        closable
        @close="updateTags(index, $event)"
      >
        <flag :iso="tag" /> &nbsp; {{ tag }}
      </b-tag>
    </template>
  </b-taginput>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'
import { countryInfo } from '@/utils/geonames'

export default {
  name: 'AllowedCountries',
  inject: ['$validator'],
  props: {
    value: Array
  },
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  data () {
    return {
      buffer: Object.assign([], this.value),
      availableCountries: [],
      filteredCountries: []
    }
  },
  methods: {
    createTag (tag) {
      if (typeof tag === 'string') {
        return tag
      } else {
        return tag.countryCode
      }
    },
    updateTags (index, event) {
      this.$refs.allowedCountryInput.removeTag(index, event)
      this.$emit('input', this.buffer)
    },
    getFilteredCountries (text) {
      this.filteredCountries = this.availableCountries.filter((option) => {
        return (
          option.countryName
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
        )
      })
    },
    setAvailableCountries () {
      countryInfo(
        this.coreStore.setting('global', 'GEONAMES_USERNAME').value,
        this.$i18n.locale
      )
        .then((results) => {
          this.availableCountries = results.data.geonames
          this.filteredCountries = this.availableCountries
        })
        .catch((error) => {
          throw error
        })
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign([], this.value)
      },
      deep: true
    },
    '$i18n.locale': function () {
      this.setAvailableCountries()
    }
  },
  mounted () {
    this.setAvailableCountries()
  }
}
</script>
